import type { MeResponse } from '@kp/contracts';
import { readsDocuments } from './permissions.ts';

/** 049: конфликт связи старого аккаунта не превращает общую сводку в личные задачи. */
export function needsEmployeeLink(me: MeResponse): boolean {
  return (
    !me.external &&
    !me.linkSession &&
    me.person === null &&
    me.roles.every(({ role }) => role === 'member') &&
    readsDocuments(me.permissions)
  );
}
